import { Team__Llamas } from "../teams/Llamas";
import { Team__Pistons } from "../teams/Pistons";



const Pistons = {
  team: Team__Pistons,
  playingPlayers: [],

  goals: 39,
  penaltyGoals: 0,
  isWinner: false,
};

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 33,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada6 = {
  jornadaPosition: 6,
  matches: [
    {
      team1: Pistons,
      team2: Llamas,

      isCompleted: true,
      isPlaying: false,
      day: "Sábado",
      date: "2026-08-01",
      time: "15:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
